import React, {Fragment} from "react";

import PageCommands from "../../../modules/app/layout/PageCommands";
import SessionStore from "../../../services/session/SessionStore";
import Button from "../../buttons/Button";

// A user can access score settings if they have read or edit access
const scoreSettingsPermissions = ["EditScoreConfig", "ReadScoreConfig"]

export default function ScoreSummaryPageCommands({}) {
  const user = SessionStore.user;
  const permissions = user && user.permissions || [];

  const scoreSettingsIsAccessible = permissions
    .findIndex(permission => scoreSettingsPermissions.includes(permission)) !== -1

  return <Fragment>
    {scoreSettingsIsAccessible && <PageCommands>
      <div className="d-flex justify-content-end">
        <a
          href="/#/admin/v2/manageScoring"
          title="home"
        >
          <Button className="floating-control" outline={true} icon="far fa-cog">
            Score Settings
          </Button>
        </a>
      </div>
    </PageCommands>}
  </Fragment>
}
